import { Form, InputGroup } from "react-bootstrap";
import {useFormContext} from "react-hook-form";

export default function PermissoesPdv({disabled}: { disabled?: boolean }) {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    
    return (
        <>
            <h6 className="fw-bold mb-3">Permissões no PDV</h6>
            <Form.Group className="mb-3" controlId="percentualDescontoMaximo" style={{ maxWidth: 320 }}>
                <Form.Label className="mb-1">Limite de desconto do usuário</Form.Label>
                <InputGroup size="sm" hasValidation>
                    <Form.Control
                        type="number"
                        min={0}
                        max={100}
                        step="0.01"
                        placeholder="Sem limite"
                        onFocus={(e) => e.currentTarget.select()}
                        isInvalid={!!errors.percentualDescontoMaximo}
                        disabled={disabled}
                        {...register("percentualDescontoMaximo", {
                            setValueAs: (v) => (v === "" || v === null || v === undefined ? null : Number(v)),
                            min: { value: 0, message: "Informe um valor entre 0% e 100%" },
                            max: { value: 100, message: "Informe um valor entre 0% e 100%" },
                        })}
                    />
                    <InputGroup.Text>%</InputGroup.Text>
                    <Form.Control.Feedback type="invalid">
                        {errors.percentualDescontoMaximo?.message as string}
                    </Form.Control.Feedback>
                </InputGroup>
                <Form.Text className="text-body-secondary">
                    Quando preenchido, substitui o desconto máximo dos produtos para este usuário no PDV. Vazio usa o desconto máximo de cada produto.
                </Form.Text>
            </Form.Group>
            <Form.Check
                type="switch"
                id="permitirVisualizarDescontoMaximo"
                label="Permite visualizar desconto máximo no PDV"
                className="mb-2"
                {...register("descontoMaximo")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="permitirVisualizarEstoquePdv"
                label="Permite visualizar estoque no PDV"
                className="mb-2"
                {...register("visualizarEstoque")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="permitirLiberarVendaCrediarioAcimaDeLimite"
                label="Permite liberar venda crediário acima do limite do cliente"
                className="mb-2"
                {...register("liberarCrediario")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="permitirVisualizarPrecoCusto"
                label="Permite visualizar preço de custo do produto no PDV"
                className="mb-2"
                {...register("precoCusto")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="abrirCaixa"
                label="Permite abrir o caixa"
                className="mb-2"
                {...register("abrirCaixa")}
                disabled={disabled}
            />
            <Form.Check
                type="switch"
                id="visulizarDetalhesCaixa"
                label="Permite visualizar detalhes do Caixa"
                className="mb-2"
                {...register("visulizarDetalhesCaixa")}
                disabled={disabled}
            />            
            <Form.Check
                type="switch"
                id="cancelaVenda"
                label="Permite cancelar vendas"
                className="mb-2"
                {...register("cancelaVenda")}
                disabled={disabled}
            />
        </>
    )
}